<template>
  <v-footer height="auto" color="secondary darken-2">
    <v-layout justify-center row wrap>
      <v-card color="secondary darken-2 white--text">
        <v-card-text class="title">Nuestas Oficinas:</v-card-text>
        <v-card-text>
          <v-tooltip top v-for="(oficina,index) in oficinas" :key="index"> 
             <v-btn
            
            
            color="white"
            flat
            round
            @click.prevent="mostrarOficina(oficina)"
            slot="activator"
          >
            <v-icon small color="white">location_on</v-icon>
            {{ oficina.nombreOficina }}
          </v-btn>
          <span>click para más información</span>
          </v-tooltip>
         
        </v-card-text>
        <v-card-text class="title">Enlaces de Interes:</v-card-text>
        <v-card-text>
          <v-layout row wrap justify-center>
            <v-flex md2 sm3 xs6 class="align-content-center">
              <a href="https://www.fiscalia.gob.bo/" target="_blank">
              <v-img
                :src="require('@/assets/fiscalia_general.png')"
                contain
                aspect-ratio="1.7"
                title="Fiscalía General del Estado"
              ></v-img>
            </a>
            </v-flex>
            <v-flex md2 sm3 xs6 class="align-content-start">
              <a href="https://magistratura.organojudicial.gob.bo/" target="_blank">
                <v-img
                  :src="require('@/assets/magistratura.png')"
                  contain
                  aspect-ratio="1.7"
                  title="Consejo de la Magistratura"
                ></v-img>
              </a>
            </v-flex>
            <v-flex md2 sm3 xs6 class="align-content-center">
              <a href="http://tsj.bo/" target="_blank">
                <v-img
                  :src="require('@/assets/tribunalsupremojusticia.png')"
                  contain
                  aspect-ratio="1.7"
                  title="Tribunal Supremo de Justicia"
                ></v-img>
              </a>
            </v-flex>
            <v-flex md2 sm3 xs6 class="align-content-center">
              <a href="http://www.tcpbolivia.bo/tcp/" target="_blank">
                <v-img
                  :src="require('@/assets/tribunal-constitucional.png')"
                  contain
                  aspect-ratio="1.7"
                  title="Tribunal Constitucional Plurinacional de Bolivia"
                ></v-img>
              </a>
            </v-flex>
            <v-flex md2 sm3 xs6 class="align-content-center">
              <a href="http://www.gacetaoficialdebolivia.gob.bo/" target="_blank">
                <v-img
                  :src="require('@/assets/gacetaboficia.png')"
                  contain
                  aspect-ratio="1.7"
                  title="Gaceta Oficial"
                ></v-img>
              </a>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card></v-card>
      <v-flex secondary darken-3 py-3 text-xs-center white--text xs12>
        <strong> {{institucion}}- RPA - &copy;{{ new Date().getFullYear() }}</strong>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="dialog"
      persistent
      :overlay="false"
      max-width="900px"
      transition="dialog-transition"
    >
      <v-card>
        <v-toolbar color="primary">
          <span class="subheading white--text">Información de Contacto de la Oficina {{map.nombreOficina}}:</span>
          <v-spacer></v-spacer>
          <v-btn icon flat dark @click="cerrarInfoOficina"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="px-4">
          <v-layout row wrap>
            <v-flex md2 xs7 class="grey--text text-sm-right px-2">
              DEPARTAMENTO :
            </v-flex>
            <v-flex md9 xs5>
              {{map.departamento}}
            </v-flex>
            <v-flex md2 xs5 class="grey--text text-sm-right px-2">
              DIRECCION :
            </v-flex>
            <v-flex md9 xs7>
            {{map.direccion}}
            </v-flex>
            <v-flex md2 xs5 class="grey--text text-sm-right px-2">
              TELEFONO(S) :
            </v-flex>
            <v-flex md9 xs7>
            {{map.telefonos}}
            </v-flex>
            <v-flex md2 xs5 class="grey--text text-sm-right px-2">
              INTERNO(S) :
            </v-flex>
            <v-flex md9 xs7>
            {{map.internos}}
            </v-flex>
            
            <v-flex xs12 mt-4>
              <map-leaflet id="office" v-if="rendermap" :lat="map.lat" :lng="map.long" :zoom="map.zoom"></map-leaflet>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Load Facebook SDK for JavaScript -->
      <div id="fb-root"></div>
      <div class="fb-customerchat"
        attribution=setup_tool
        page_id="104703438070534"
        greeting_dialog_display="fade"
        theme_color="#0A7CFF">
      </div>
  </v-footer>
</template>
<script>
import MapLeaflet from "@/common/util/ViewMap";
const zoom = 16;
export default {
  components: {
    MapLeaflet
  },
  data() {
    return {
      map: {},
      dialog: false,
      rendermap: false,
      institucion: "Ministerio de Justicia y Transparencia Institucional"
    };
  },
  created(){
    return  (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/es_ES/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'))
  },
   mounted() {
    window.fbAsyncInit = function() {
          FB.init({
            xfbml            : true,
            version          : 'v9.0'
          });
        };
  },
  computed: {
    oficinas() {
      return this.$store.state.oficinas;
    }
  },
  methods: {
    mostrarOficina(data) {
      this.dialog = true;
      this.rendermap = true;
      this.map=data;
    },
    cerrarInfoOficina(){
      this.dialog = false;
      this.rendermap = false;
      this.map={};
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Footer.vue